/*
|--------------------------------------------------------------------------
| Paywall: MPP
|--------------------------------------------------------------------------
*/

/**
 * @namespace
 */
__gh__webApp.paywall.mpp = {
	"init": function(){
/*
		__gh__webApp.common.loadScript({
			"src": "http://redesign.gatehousemedia.com/jason/js/paywall/mpp/main.js"
		});
*/
	},


	"loadRegistrationLibrary": function(){
/*
		__gh__webApp.common.loadScript({
			"src": "http://redesign.gatehousemedia.com/jason/js/paywall/registration.js"
		});
*/
	},


	"loadCheckoutLibrary": function(){
/*
		__gh__webApp.common.loadScript({
			"src": "http://redesign.gatehousemedia.com/jason/js/paywall/checkout.js"
		});
*/
	},


	"meterArticle": function(articleID){

	},
	
	"isUserLoggedIn": function(){
	}
};
